import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectCurrentStep, setCurrentStep } from '@/store/reducers/survey/surveySlice';
import { ROUTES } from '@/constants/routes';

export default function useSurveyNavigate() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentStep = useAppSelector(selectCurrentStep);
  const currentUrl = `${ROUTES.SURVEY}${currentStep ? `?step=${currentStep}` : ''}`;

  const goToStep = (offset: number) => {
    const step = (currentStep ?? 0) + offset;

    navigate(`${ROUTES.SURVEY}?step=${step}`);
    dispatch(setCurrentStep(step));
  };

  const goToBankStep = () => {
    navigate(`${ROUTES.SURVEY}?step=${18}`);
    dispatch(setCurrentStep(18));
  };

  return {
    currentUrl,
    next: () => goToStep(1),
    back: () => goToStep(-1),
    goToBankStep,
  };
}
